import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button, Status, RadioGroup, RadioButton, I18n } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const FirewallForm = ({ level, setNewLevel, levelItems, onSave }) => (
  <Status className={cx('component')}>
    <RadioGroup
      value={`${level}`}
      onChange={setNewLevel}
      name="firewall-level"
    >
      {levelItems.map(({ level: itemLevel, title, description }) => (
        <RadioButton key={itemLevel} value={`${itemLevel}`}>
          <div className={cx('firewallLevelName')}>
            {title}
          </div>
          {description && (
          <div className={cx('firewallLevelDescription')}>
            {description}
          </div>
          )}
        </RadioButton>
      ))}
    </RadioGroup>

    <Button className="default" onClick={onSave}>
      <I18n path="common.saveChanges" />
    </Button>
  </Status>
);

FirewallForm.propTypes = {
  level: PropTypes.string,
  setNewLevel: PropTypes.func,
  levelItems: PropTypes.arrayOf({
    level: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  onSave: PropTypes.func,
};
